import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 8l16 0","key":"svg-0"}],["path",{"d":"M4 16l16 0","key":"svg-1"}]]

const IconMenu = createReactComponent('outline', 'menu', 'Menu', __iconNode);

export default IconMenu;